<template>

  <div class="row" ref="newsForm">
    <div class="col-xs-12 col-md-12 col-sm-12">
      <ValidationObserver v-slot="{ handleSubmit }" ref="formValidator">
        <div class="col-12">
          <div class="card card-wizard" id="wizardCard">
            <form-wizard shape="tab"
                         :title="formTitle"
                         :subtitle="''"
                         error-color="#FB404B"
                         color="#35495E"
                         ref="panelFormWizard">
              <tab-content title="English Content"
                           class="col-12"
                           icon="nc-icon nc-album-2"
                           :before-change="() => validateStep('englishStep')">
                <english-step :formData="formData ? formData['en'] : defaultFormData['en']"
                              :editMode="editMode"
                              ref="englishStep"
                              :builderData="builderData"
                              @on-validated="onStepValidated" @submit-step="submitStep"></english-step>
              </tab-content>
              <tab-content v-for="(lang, index) in languageList" :key="index" :title="lang.label+' Content'"
                           class="col-12"
                           icon="nc-icon nc-album-2"
                           :before-change="() => validateStep(lang.value)">
                <other-languages-step
                  :formData="formData ? formData[lang.value] : defaultFormData[lang.value]"
                  :editMode="editMode"
                  :isSubmit="languageList.length - 1 === index"
                  :lang="lang" :ref="lang.value" @on-validated="onStepValidated"
                  @submit-step="submitStep"></other-languages-step>
              </tab-content>

              <button slot="prev" class="btn btn-default btn-fill btn-wd btn-back">Back</button>
              <button slot="next" class="btn btn-default btn-fill btn-wd btn-next">Next</button>
              <button slot="finish" class="btn btn-success btn-fill btn-wd" :disabled="entityNotFoundError || submitting">Finish</button>
            </form-wizard>
          </div>
        </div>
      </ValidationObserver>

    </div>

  </div>
</template>
<script>
import { extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import EnglishStep from "./Wizard/EnglishStep";
import OtherLanguagesStep from "./Wizard/OtherLanguagesStep";
import {mapGetters} from "vuex";



extend("required", {
  message: "{_field_} is required"
});

export default {

  components: {
    FormWizard,
    TabContent,
    OtherLanguagesStep,
    EnglishStep,
  },

  data() {
    return {
      editMode: false,
      loader: {},
      id: undefined,
      editorConfig: this.getEditorConfig(),
      editorKey: process.env.VUE_APP_TINY_EDITOR_KEY,
      imagesExtensions: this.getImagesExtensions(),
      formTitle: "",
      entityNotFoundError: false,
      submitting: false,
      formData: {},
      reverseSearchInProgress: false,
      defaultFormData: {
        title: "",
        url: "",
        news_type_id: "",
        image: "",
        content: "",
        is_active: true,
        is_featured: false,
        show_in_popup: false,
        gallery: [],
        linked_initiatives: [],
        date: null,
        files: [],
        video_type: '',
        uploaded_video: "",
        embedded_video: "",
        is_updated: false,
      },
      wizardModel: {},
      builderData: {
        newsType: [],
        initiatives: [],
        VideoTypes: [],
      },

    };
  },
  computed: {
    ...mapGetters({
      languageList: "global/languageList"
    })
  },
  mounted() {
    this.loader = this.$loading.show({
      container: this.$refs.newsForm
    });
    this.setNullFormData();
    this.id = this.$route.params['id'];
    let data = {id: this.id}
    // First load news builder data
    this.axios.post("news/builder", data).then((response) => {
      this.builderData.newsType = response.data.newsTypes;
      this.builderData.initiatives = response.data.initiatives || [];
      this.builderData.VideoTypes = response.data.videoTypes;

      // Load initiatives separately using the initiatives index endpoint
      return this.axios.post("initiatives/index", {
        per_page: 1000, // Get a large number to include all initiatives
        page: 1
      });
    }).then((initiativeResponse) => {
      
      // Set initiatives data from the initiatives index
      if (initiativeResponse && initiativeResponse.data) {
        // Try different possible response structures
        if (initiativeResponse.data.data && Array.isArray(initiativeResponse.data.data)) {
          this.builderData.initiatives = initiativeResponse.data.data;
        } else if (Array.isArray(initiativeResponse.data)) {
          this.builderData.initiatives = initiativeResponse.data;
        } else if (initiativeResponse.data.initiatives && Array.isArray(initiativeResponse.data.initiatives)) {
          this.builderData.initiatives = initiativeResponse.data.initiatives;
        }
      }

      this.id = this.$route.params['id'];

      if (this.id !== undefined) {
        this.editMode = true;
        this.formTitle = "Edit News";
        this.getNews();
      } else {
        this.editMode = false;
        this.formTitle = "Add News";
        this.loader.hide();
      }
    }).catch((error) => {
      console.error("Error loading data:", error);
      // Even if initiatives loading fails, continue with news loading
      this.id = this.$route.params['id'];

      if (this.id !== undefined) {
        this.editMode = true;
        this.formTitle = "Edit News";
        this.getNews();
      } else {
        this.editMode = false;
        this.formTitle = "Add News";
        this.loader.hide();
      }
    })

  },
  methods: {
    getNews() {
      let data = {
        'id': this.id,
      };
      this.axios.post("news/get", data).then((response) => {
        this.formData = response.data;
        
        console.log("📰 Raw news data from API:", response.data);
        console.log("📰 Available fields in en:", Object.keys(response.data['en'] || {}));
        
        // Load directly linked initiatives from different possible field names
        let directlyLinkedInitiatives = [];
        
        // Check all possible field names for linked initiatives
        const fieldChecks = [
          { name: 'linkedInitiatives', value: response.data['en']?.linkedInitiatives },
          { name: 'linked_initiatives', value: response.data['en']?.linked_initiatives },
          { name: 'initiatives', value: response.data['en']?.initiatives },
          { name: 'initiative_ids', value: response.data['en']?.initiative_ids },
          { name: 'initiativeIds', value: response.data['en']?.initiativeIds }
        ];
        
        console.log("📰 Checking possible fields:", fieldChecks);
        
        for (let check of fieldChecks) {
          console.log(`📰 Field '${check.name}':`, check.value, `(type: ${typeof check.value}, isArray: ${Array.isArray(check.value)})`);
          
          if (check.value) {
            // Handle different data types
            if (Array.isArray(check.value) && check.value.length > 0) {
              directlyLinkedInitiatives = check.value.map(initiative => 
                typeof initiative === 'object' ? initiative.id : initiative
              );
              console.log(`✅ Found array in '${check.name}':`, directlyLinkedInitiatives);
              break;
            } else if (typeof check.value === 'string' && check.value.trim() !== '') {
              // Handle comma-separated string
              try {
                directlyLinkedInitiatives = check.value.split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id));
                console.log(`✅ Found string in '${check.name}', converted to:`, directlyLinkedInitiatives);
                break;
              } catch (e) {
                console.warn(`❌ Failed to parse string '${check.name}':`, e);
              }
            } else if (typeof check.value === 'number') {
              directlyLinkedInitiatives = [check.value];
              console.log(`✅ Found number in '${check.name}':`, directlyLinkedInitiatives);
              break;
            }
          }
        }
        
        // Also check for reverse relationships (initiatives that link to this news)
        let reverseLinkedInitiatives = (response.data['en'].initiativesLinkingToThis || response.data['en'].reverse_linked_initiatives || []).map(initiative => initiative.id);
        
        // Combine both directions and remove duplicates
        let allLinkedInitiatives = [...new Set([...directlyLinkedInitiatives, ...reverseLinkedInitiatives])];
        
        console.log("📰 Final linked initiatives:", allLinkedInitiatives);
        this.formData['en'].linked_initiatives = allLinkedInitiatives;
        
        // Temporarily disable manual reverse search to isolate backend error
        /*
        if (reverseLinkedInitiatives.length === 0 && this.builderData.initiatives && this.builderData.initiatives.length > 0) {
          console.log("🔄 No reverse relationships found from backend, searching manually...");
          this.findReverseLinkedInitiatives();
        } else if (reverseLinkedInitiatives.length > 0) {
          console.log("✅ Found reverse relationships from backend:", reverseLinkedInitiatives);
        }
        */
        console.log("ℹ️ Manual reverse search disabled to isolate backend error");
        
        // Convert numeric boolean fields to actual booleans
        this.formData['en'].is_active = this.formData['en'].is_active === 1 || this.formData['en'].is_active === true;
        this.formData['en'].is_featured = this.formData['en'].is_featured === 1 || this.formData['en'].is_featured === true;
        this.formData['en'].show_in_popup = this.formData['en'].show_in_popup === 1 || this.formData['en'].show_in_popup === true;
        this.formData['en'].is_updated = this.formData['en'].is_updated === 1 || this.formData['en'].is_updated === true;
        
        this.vueDate();
        this.loader.hide();
      }).catch((error) => {
        if (error.response.status === 404) {
          this.entityNotFoundError = true;
          this.$notify({
            message: "News Not Found",
            timeout: 2000,
            type: 'danger'
          });
          this.loader.hide();
        } else {
          console.error(error);
        }
      })
    },
    submit() {
      let request;
      let successMessage;
      this.submitting = true;
      this.laravelDate();
      if (this.formData['en'].video_type === "UPLOADED") {
        this.formData['en'].embedded_video = '';
      } else {
        this.formData['en'].uploaded_video = '';
      }
      
      // Map linked_initiatives to initiativeIds for API - ensure clean array of integers
      if (this.formData['en'] && this.formData['en'].linked_initiatives) {
        let linkedIds = this.formData['en'].linked_initiatives;
        
        // Ensure it's an array
        if (!Array.isArray(linkedIds)) {
          if (typeof linkedIds === 'string') {
            linkedIds = linkedIds.split(',').map(id => id.trim());
          } else if (typeof linkedIds === 'number') {
            linkedIds = [linkedIds];
          } else {
            linkedIds = [];
          }
        }
        
        // Convert to integers and filter out invalid values
        this.formData['en'].initiativeIds = linkedIds
          .map(id => parseInt(id))
          .filter(id => !isNaN(id) && id > 0);
          
        console.log("📤 Submitting initiativeIds:", this.formData['en'].initiativeIds);
      } else {
        this.formData['en'].initiativeIds = [];
      }
      
      if (this.editMode === true) {
        request = this.axios.put("news/update/" + this.id, this.formData);
        successMessage = "News Updated Successfully";
      } else {
        request = this.axios.post("news/create", this.formData);
        successMessage = "News Added Successfully";
      }

      request.then((response) => {
        this.$notify({
          message: successMessage,
          timeout: 1000,
          type: 'success'
        })
        this.$router.push("/news/list");
      }).catch((error) => {
        if (error.response.status === 422) {
          this.$refs.formValidator.setErrors(error.response.data.errors);
          this.$refs.panelFormWizard.navigateToTab(0);
        } else {
          console.log(error.response)
        }
      }).finally(() => {
        this.submitting = false;
      })
    },
    vueDate(){
      this.formData.date = (this.formData.date)? this.formData.date.replace(' ', 'T'):this.formData.date;
    },
    laravelDate(){
      this.formData.date = (this.formData.date)? this.formData.date.replace('T', ' '):this.formData.date;
    },
    async findReverseLinkedInitiatives() {
      if (!this.id || this.reverseSearchInProgress) {
        console.log("❌ Skipping reverse search - already in progress or no ID");
        return;
      }
      
      this.reverseSearchInProgress = true;
      console.log("🔗 Finding reverse linked initiatives for news ID:", this.id);
      
      try {
        // Get all initiatives first
        const initiativesResponse = await this.axios.post("initiatives/index", {
          per_page: 1000,
          page: 1
        });
        
        console.log("📋 Got initiatives list:", initiativesResponse.data);
        const initiatives = initiativesResponse.data.data || initiativesResponse.data || [];
        console.log("📋 Processing", initiatives.length, "initiatives");
        
        let reverseLinkedInitiatives = [];
        
        // Check each initiative individually
        for (let initiative of initiatives) {
          try {
            console.log(`🔍 Checking initiative ${initiative.id}: ${initiative.title}`);
            
            const detailResponse = await this.axios.post("initiatives/get", { 
              id: initiative.id 
            });
            
            console.log(`📊 Initiative ${initiative.id} details:`, detailResponse.data);
            
            // Check if this initiative has linked news
            const linkedNews = detailResponse.data?.en?.news || [];
            console.log(`📰 Initiative ${initiative.id} linked news:`, linkedNews);
            
            // Check if current news ID is in the linked news
            const hasCurrentNews = linkedNews.some(newsItem => {
              const newsId = newsItem.id || newsItem;
              const matches = newsId == this.id;
              console.log(`🔍 Checking news ${newsId} == ${this.id}:`, matches);
              return matches;
            });
            
            if (hasCurrentNews) {
              console.log(`✅ Initiative ${initiative.id} links to news ${this.id}`);
              reverseLinkedInitiatives.push(initiative.id);
            }
            
          } catch (error) {
            console.warn(`❌ Error checking initiative ${initiative.id}:`, error);
          }
        }
        
        console.log("✅ Found reverse linked initiatives:", reverseLinkedInitiatives);
        
        if (reverseLinkedInitiatives.length > 0) {
          // Combine with existing linked initiatives and remove duplicates
          const currentLinkedInitiatives = this.formData['en'].linked_initiatives || [];
          const allLinkedInitiatives = [...new Set([...currentLinkedInitiatives, ...reverseLinkedInitiatives])];
          
          console.log("🔄 Updated linked initiatives:", allLinkedInitiatives);
          console.log("🔄 Before update - formData linked_initiatives:", this.formData['en'].linked_initiatives);
          
          // Use Vue.set to ensure reactivity
          this.$set(this.formData['en'], 'linked_initiatives', allLinkedInitiatives);
          
          console.log("🔄 After update - formData linked_initiatives:", this.formData['en'].linked_initiatives);
          
          // Force component update with a slight delay to ensure DOM is ready
          this.$nextTick(() => {
            console.log("🔄 NextTick - forcing update...");
            console.log("🔄 Current formData['en']:", this.formData['en']);
            console.log("🔄 linked_initiatives value:", this.formData['en'].linked_initiatives);
            
            this.$forceUpdate();
            
            // Also trigger any child component updates
            if (this.$refs.englishStep) {
              this.$refs.englishStep.$forceUpdate();
              console.log("🔄 EnglishStep component force updated");
              
              // Try to directly update the child component's formData
              if (this.$refs.englishStep.formData) {
                console.log("🔄 Before: EnglishStep formData.linked_initiatives =", this.$refs.englishStep.formData.linked_initiatives);
                this.$refs.englishStep.formData.linked_initiatives = allLinkedInitiatives;
                console.log("🔄 After: EnglishStep formData.linked_initiatives =", this.$refs.englishStep.formData.linked_initiatives);
              }
              
              // Call the manual update method
              if (this.$refs.englishStep.updateLinkedInitiatives) {
                this.$refs.englishStep.updateLinkedInitiatives(allLinkedInitiatives);
              }
            }
            
            // Trigger change event to make sure the form wizard knows data changed
            this.$emit('data-updated', this.formData);
          });
        } else {
          console.log("ℹ️ No reverse linked initiatives found");
        }
        
      } catch (error) {
        console.warn("❌ Error fetching reverse linked initiatives:", error);
      } finally {
        this.reverseSearchInProgress = false;
      }
    },
    validateStep(ref) {
      if (Array.isArray(this.$refs[ref])){
        return this.$refs[ref][0].validate();
      }else{
        return this.$refs[ref].validate();
      }
    },
    onStepValidated(validated, model) {
      this.wizardModel = {...this.wizardModel, ...model}
    },
    submitStep(data, lang, isSubmit){
      this.formData[lang] = data;
      if (isSubmit){
        this.submit();
      }
    },
    setNullFormData(){
      this.defaultFormData['en'] = {
        name: '',
        ident: '',
      };
      this.languageList.forEach(lang => {
        this.defaultFormData[lang] = {
          name: '',
          ident: '',
        }
      })
    },
  }
}
</script>
